import StatusChip from 'src/components/StatusChip';

// Files carry no signer of their own, so the tables that list them mark the gap inline rather than
// splitting the unsigned ones into a list of their own. It reads in the neutral grey the enum
// modules use for no status, because unsigned is a fact about the file, not a verdict on it.
const UnsignedChip = () => (
  <StatusChip
    label="Unsigned"
    color="#9E9E9E"
    backgroundColor="#9E9E9E1F"
    sx={{ height: 18, fontSize: '0.62rem', '& .MuiChip-label': { px: 0.75 } }}
  />
);

export default UnsignedChip;
